import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import moment from "moment";
import { Modal } from "antd";
import {
    RiCheckboxCircleLine,
    RiAlertLine,
    RiInformationLine,
} from "react-icons/ri";
import {
    getParamsList,
    postAdd,
} from "../../../helpers/Helper";
import {
    apiError,
    eligibilityListSuccessful,
    eligibilityByIDSuccessful,
    getEligibilityList,
    isModelVisible,
    loanProductsSuccessful,
    mobileLookupSuccessful,
    mobileLookupError,
    panLookupSuccessful,
    panLookupError,
    configSuccessful,
    configError,
    usageSuccessful,
    usageError,
    getUsage,
} from "./loanEligibility.slice";

function* EligibilityList({ payload }) {
    var data = payload;
    var params = {};
    for (const k in data) {
        if (Object.hasOwnProperty.call(data, k)) {
            if (k === "currentSort" || k === "sortOrder") {
                params.ordering = data.sortOrder + data.currentSort;
            } else {
                if (data[k] != "" && k != null && k != "no_of_pages") {
                    if (k == "start_date") {
                        params[k] = moment(data[k]).format("YYYY-MM-DD");
                    } else if (k == "end_date") {
                        params[k] = moment(data[k]).add(1, "days").format("YYYY-MM-DD");
                    } else {
                        params[k] = data[k];
                    }
                }
            }
        }
    }
    try {
        const response = yield call(getParamsList, "/loaneligibility/checks/", params);
        yield put(eligibilityListSuccessful(response));
    } catch (error) {
        yield put(apiError(error));
    }
}

function* EligibilityByID({ payload }) {
    try {
        const response = yield call(
            getParamsList,
            "/loaneligibility/checks/" + payload.row.id,
            {}
        );
        yield put(eligibilityByIDSuccessful({ response, type: payload.type }));
    } catch (error) {
        yield put(apiError(error));
    }
}

function* AddEligibilityCheck({ payload }) {
    try {
        const response = yield call(postAdd, "/loaneligibility/check/", payload);
        if (response.status === 201) {
            Modal.success({
                icon: (
                    <span className="remix-icon">
                        <RiCheckboxCircleLine />
                    </span>
                ),
                title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
                content: (
                    <div>
                        <p className="hp-p1-body hp-text-color-black-80">
                            Eligibility check completed successfully!
                        </p>
                    </div>
                ),
            });
            yield put(getEligibilityList({ page: 1, search: "", page_size: 10 }));
            yield put(isModelVisible(false));
        } else {
            Modal.error({
                icon: (
                    <span className="remix-icon">
                        <RiAlertLine />
                    </span>
                ),
                title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
                content: (
                    <div>
                        <p className="hp-p1-body hp-text-color-black-80">
                            Sorry! Unable to complete eligibility check. Please try again!
                        </p>
                    </div>
                ),
            });
        }
    } catch (error) {
        Modal.error({
            icon: (
                <span className="remix-icon">
                    <RiAlertLine />
                </span>
            ),
            title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
            content: (
                <div>
                    <p className="hp-p1-body hp-text-color-black-80">
                        {error?.response?.data?.message || "Sorry! Getting server side issue!"}
                    </p>
                </div>
            ),
        });
        yield put(apiError(error));
    }
}

function* watchGetEligibilityList() {
    yield takeEvery("loanEligibility/getEligibilityList", EligibilityList);
}

export function* watchGetEligibilityByID() {
    yield takeEvery("loanEligibility/getEligibilityByID", EligibilityByID);
}

export function* watchAddEligibilityCheck() {
    yield takeEvery("loanEligibility/eligibilityCheckAdd", AddEligibilityCheck);
}

function* LoanProductsList() {
    try {
        const response = yield call(getParamsList, "/loaneligibility/loan-products/", {});
        yield put(loanProductsSuccessful(response));
    } catch (error) {
        yield put(apiError(error));
    }
}

export function* watchGetLoanProducts() {
    yield takeEvery("loanEligibility/getLoanProducts", LoanProductsList);
}

function* MobileLookup({ payload }) {
    try {
        const response = yield call(postAdd, "/loaneligibility/mobile/lookup/", payload);
        if (response.status === 200 && response.data?.success) {
            const data = response.data;
            
            // Map the response data to form fields
            const mappedData = {
                mobile: data.mobile || payload.mobile,
                full_name: data.full_name || data.raw?.details?.personal_info?.full_name || "",
                date_of_birth: data.date_of_birth || data.raw?.details?.personal_info?.dob || null,
                pan: data.pan || data.raw?.details?.identity_info?.pan_number?.[0]?.id_number || "",
            };

            yield put(mobileLookupSuccessful(mappedData));
            
            // Fetch usage data after successful lookup
            yield put(getUsage());
            
            Modal.success({
                icon: (
                    <span className="remix-icon">
                        <RiCheckboxCircleLine />
                    </span>
                ),
                title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
                content: (
                    <div>
                        <p className="hp-p1-body hp-text-color-black-80">
                            Mobile details fetched successfully!
                        </p>
                    </div>
                ),
            });
        } else {
            yield put(mobileLookupError());
            Modal.warning({
                icon: (
                    <span className="remix-icon">
                        <RiInformationLine />
                    </span>
                ),
                title: <h5 className="hp-mb-0 hp-font-weight-500">No Data Found</h5>,
                content: (
                    <div>
                        <p className="hp-p1-body hp-text-color-black-80">
                            No details found for this mobile number.
                        </p>
                    </div>
                ),
            });
        }
    } catch (error) {
        yield put(mobileLookupError());
        Modal.error({
            icon: (
                <span className="remix-icon">
                    <RiAlertLine />
                </span>
            ),
            title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
            content: (
                <div>
                    <p className="hp-p1-body hp-text-color-black-80">
                        {error?.response?.data?.message || "Sorry! Unable to fetch mobile details!"}
                    </p>
                </div>
            ),
        });
    }
}

export function* watchMobileLookup() {
    yield takeEvery("loanEligibility/mobileLookup", MobileLookup);
}

function* PanLookup({ payload }) {
    try {
        const response = yield call(postAdd, "/loaneligibility/pan/lookup/", payload);
        if (response.status === 200 && response.data?.success) {
            const data = response.data;
            
            // Map the response data to form fields
            const mappedData = {
                pan: data.pan || payload.pan,
                full_name: data.full_name || data.raw?.full_name || "",
                date_of_birth: data.date_of_birth || data.raw?.dob || null,
                mobile: data.mobile || "",
            };

            yield put(panLookupSuccessful(mappedData));
            
            // Fetch usage data after successful lookup
            yield put(getUsage());
            
            Modal.success({
                icon: (
                    <span className="remix-icon">
                        <RiCheckboxCircleLine />
                    </span>
                ),
                title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
                content: (
                    <div>
                        <p className="hp-p1-body hp-text-color-black-80">
                            PAN details fetched successfully!
                        </p>
                    </div>
                ),
            });
        } else {
            yield put(panLookupError());
            Modal.warning({
                icon: (
                    <span className="remix-icon">
                        <RiInformationLine />
                    </span>
                ),
                title: <h5 className="hp-mb-0 hp-font-weight-500">No Data Found</h5>,
                content: (
                    <div>
                        <p className="hp-p1-body hp-text-color-black-80">
                            No details found for this PAN number.
                        </p>
                    </div>
                ),
            });
        }
    } catch (error) {
        yield put(panLookupError());
        Modal.error({
            icon: (
                <span className="remix-icon">
                    <RiAlertLine />
                </span>
            ),
            title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
            content: (
                <div>
                    <p className="hp-p1-body hp-text-color-black-80">
                        {error?.response?.data?.message || "Sorry! Unable to fetch PAN details!"}
                    </p>
                </div>
            ),
        });
    }
}

export function* watchPanLookup() {
    yield takeEvery("loanEligibility/panLookup", PanLookup);
}

function* GetConfig() {
    try {
        const response = yield call(getParamsList, "/loaneligibility/config/", {});
        yield put(configSuccessful(response));
    } catch (error) {
        yield put(configError());
    }
}

export function* watchGetConfig() {
    yield takeEvery("loanEligibility/getConfig", GetConfig);
}

function* GetUsage() {
    try {
        const response = yield call(getParamsList, "/loaneligibility/usage/", {});
        yield put(usageSuccessful(response));
    } catch (error) {
        yield put(usageError());
    }
}

export function* watchGetUsage() {
    yield takeEvery("loanEligibility/getUsage", GetUsage);
}

function* loanEligibilitySaga() {
    yield all([
        fork(watchGetEligibilityList),
        fork(watchGetEligibilityByID),
        fork(watchAddEligibilityCheck),
        fork(watchGetLoanProducts),
        fork(watchMobileLookup),
        fork(watchPanLookup),
        fork(watchGetConfig),
        fork(watchGetUsage),
    ]);
}

export default loanEligibilitySaga;
